import styled from 'styled-components';
import { regularWhite } from '../../../design-tokens';
import { Heading5 } from '../../../typography/Heading.styles';
import { PlayPrefix } from '../../../typography/PlayPrefix.styles';
import PlayText from '../../../typography/PlayText/PlayText';

export const StyledCaption = styled.div`
    box-sizing: border-box;
    display: block;
    width: 100%;
    padding: 15px 15px 25px;
    color: ${regularWhite};
`;

export const Byline = styled(PlayPrefix)`
    display: block;
    margin-bottom: 3px;
`;

export const Heading = styled(Heading5)`
    display: inline-block;
    margin-bottom: 2px;
    margin-top: 0;
`;

export const Subheading = styled(PlayText)`
    line-height: 1.4;
    margin-top: 2px;
`;
